import type { RouteRecordRaw } from 'vue-router'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./pages/LoginPage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('./pages/ResetPasswordPage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/set-password',
    name: 'set-password',
    component: () => import('./pages/SetPasswordPage.vue'),
    meta: { requiresAuth: false }
  }
]
